export const course_number = 'CMSC471'
export const course_full_name = 'Introduction to Information Visualization'
export const course_sub_name = ''
export const course_short_name = 'introvis'
export const course_time = 'MW 2:00pm - 3:15pm'
export const semester = 'Spring 2025'

export const course_objective_long = `
<p>
<b>Description</b>&#8212;Datasets are becoming increasingly large and complex, requiring intuitive ways to explore and interpret them quickly and efficiently. In this case, a picture is worth a thousand words: visualizations enable us to transform data into images that are easier to understand and reason about, compared to raw numbers and raw text. Visualizations are critical tools in externalizing and organizing our knowledge and insights, whether to explore collected datasets to improve our understanding of the physical world, to assess and debug analysis/experimental workflows, or to present new and interesting results to diverse audiences. In this course we will study techniques and algorithms for creating effective visualizations based on principles from graphic design, perceptual psychology, and cognitive science. Students will learn how to design and build interactive visualizations for the web, using the D3.js (Data-Driven Documents) framework.

</p>

<p>
<b>Course objectives</b>&#8212;By the end of this course, students can
<ul>
<li>understand key visualization techniques and theory.</li>
<li>implement interactive data visualizations using D3.js.</li>
<li>design, evaluate, and critique visualization designs.</li>
<li>develop a substantial visualization project.</li>
</ul>
</p>

<p><b>Note: We reserve the right to add, remove, or alter the syllabus as needed throughout the semester. Major changes will be notified before the release.</b></p> 
`

/**/

export const course_location = `CSI 3117`

export const syllabus_intro = ` Most materials will be released publicly on this website. Confidential content will be released on a UMD google drive or through Canvas. As all these topics are related to visualization, I sometimes omit the word "Visualization" in the lecture title for brevity. <br/>

&#128187; = programming labs; 	&#128397; = non-programming design labs;  &#128172; = discussion labs`


export const howitworks =`
<p>We expect students to submit each lab by the end of class or by the following Wednesday. Labs are graded at the time of submission. Programming assignments are graded as a demo (we also look at code briefly).
</p>
<p>
During in-class labs, you can use Google and its AI overview, while GPT or similar generative AIs are strictly banned unless the lab is designed to do so. You can use GPT in your assignments, but please also document your usage of AI. 
</p>
`



export const assignments = [
    
    {
        'name': 'In-class labs (solo)',
        'summary': '',
        'divs': [
            {
                'perc': .39,
                'id': 'labs',
                'requirement': `(13 labs * 3%) = 39%. Students are expected to ask questions in class and talk to each other.`,
                'long_requirement': null
            }]
    },
    {
        'name': 'Assignments (group)',
        'summary': '',
        'divs': [
            {
                'perc': .07,
                'id': 'a1',
                'requirement': '<a href="https://fumeng-yang.github.io/CMSC471/handouts/A1-critique.html">A1: Visualization Critiques</a> (recommend 1-2 people, up to 3)',
                'long_requirement': null
            },
            {
                'perc': .12,
                'id': 'a2',
                'requirement': '<a href="https://fumeng-yang.github.io/CMSC471/handouts/A2-interactive.html">A2: Interactive Visualization</a> (2-3 people)',
                'long_requirement': null
            },
            {
                'perc': .12,
                'id': 'a2',
                'requirement': '<a href="https://fumeng-yang.github.io/CMSC471/handouts/A3-hat.html">A3: White Hat / Black Hat Visualization</a> (2-3 people)',
                'long_requirement': null
            }]
    },
    {
        'name': 'Final Assessment: Final Project (3-5 people)',
        'summary': '',
        'divs': [
            {
                'perc': .30,
                'id': 'final',
                'requirement': 'This includes a proposal (3%), a milestone (3% as Lab 13), and a talk-through (3%) on the demo day. There is no written final exam.',
                'long_requirement': ``
            }]
    }
]




export const syllabus = `
| Week | Mon | Lecture | Wed  |  In-class Lab | Assignment |

|------|----------|------------|------| ------------|------|

| 1    | 01/27/2025       |    [Introduction](slides/w1-intro.pdf)      | 01/29/2025               |   Lab [##X]: &#128187; [Web Development Basics](handouts/lab0-handout.html)         |            |

| 2    | 02/03/2025       |    [Visual Encodings](slides/w2-encoding.pdf)       |02/05/2025               |    Lab [##X]: &#128187; [Intro to D3](handouts/lab1-handout.html)     |          |

| 3    | 02/10/2025       |    [Perception & Cognition](slides/w3-perception_and_cognition.pdf)       | 02/12/2025               |  Lab [##X]: &#128187;  [A Basic Bar Chart](handouts/lab2-handout.html) [[slides]](slides/w3-lab.pdf)      |  [A1 out](handouts/A1-critique.html)       |

| 4    | 02/17/2025       |    [Color Theory](slides/w4-color.pdf)            |02/19/2025               |   Lab [##X]: &#128187; [Enter, Update, and Exit](handouts/lab3-handout.html)   |         |

| 5    | 02/24/2025       |   [Task & Interaction](slides/w5-interaction.pdf)       |02/26/2025               |    Lab [##X]:  &#128187; [Interaction & Animated Transition I](handouts/lab45-handout.html)       |   A1 due; [A2 out](handouts/A2-interactive.html)      |

| 6    | 03/03/2025       |     [Animation](slides/w6-animation.pdf)       |03/05/2025               |    Lab [##X]:  &#128187; [Interaction & Animated Transition II](handouts/lab45-handout.html)        |          |

| 7    | 03/10/2025       |    [Storytelling & Narrative](slides/w7-storytelling.pdf)         |03/12/2025               |   Lab [##X]: 	&#128397;  [EDA & Tableau](handouts/lab6-handout.html) [[slides]](slides/March-12.pdf)         |     A2 due; [A3 out](handouts/A3-hat.html)   |

| 8  | 03/17/2025       | Spring Break | 03/19/2025            | Spring Break  |            |          |

| 9    | 03/24/2025       |    [Tree & Graph](slides/w9-tree.pdf)     | 03/26/2025               |   Lab [##X]:  &#128187; [Layout](handouts/lab7-handout.html)   |  [FP out](handouts/FP.html)        |

| 10   | 03/31/2025       |    [Time & Multivariate](slides/w10-time.pdf)         | 04/02/2025               |   Lab [##X]:  &#128187; ["Spiral Days"  I](handouts/lab8-9-handout.html)    |  A3 due      |

| 11   | 04/07/2025       |     Immersive Analytics  ([Sungwon In](https://www.hisungwon.com/))  | 04/09/2025               |   Lab [##X]:  &#128187; ["Spiral Days" II](handouts/lab8-9-handout.html)          |     FP proposal due    |

| 12   | 04/14/2025       |     Visualization Literacy  ([Charles Cui](https://digital-flaneur.github.io/))     | 04/16/2025               |  Lab [##X]: &#128172;   [Project Discussion](handouts/FP-discussion.html) [[slides]](slides/ui.pdf)    |          |

| 13   | 04/21/2025       |       [Data Journalism & Map](slides/w13-map.pdf)      | 04/23/2025               |    Lab [##X]:   &#128187; [U.S. Election Map](handouts/lab11-handout.html)      |          |

| 14   | 04/28/2025       |    [Interpretability & Explainability](slides/w14-interpretability.pdf)      | 04/30/2025               |   Lab [##X]:  &#128187;  [A Bite of R & ggplot2](handouts/lab12-handout.html) |          |

| 15   | 05/05/2025       |      [Uncertainty & Probability](slides/w15-uncertainty.pdf)                   | 05/07/2025               |  Lab [##X]: &#128172; [Final Project Milestone](handouts/FP-milestone.html)       |    |

| 16   | 05/12/2025       |      Final Project Clinic Day                   | 05/14/2025               |  Reading Period       |    |

| 17   | 05/19/2025       |   Final Project Demo 4-6pm   |  |     |    Final Project due     |
`

// "[##X] Rethinking the Ranks of Visual Channels  [[link]](https://arxiv.org/abs/2107.11367) [reviews] <br/> [##X] The Risks of Ranking: Revisiting Graphical Perception to Model Individual Differences in Visualization Performance  [[link]](https://mucollective.northwestern.edu/files/2022-perception-individual-differences.pdf)"
//  [##X] Graphical Perception: Theory, Experimentation, and Application to the Development of Graphical Method  [[link]](https://faculty.washington.edu/aragon/classes/hcde511/s12/readings/cleveland84.pdf) <br/>

export const collaboration_policy = `
<p> 
We encourage collaboration and discussion among students. However, solo assignments should be primarily completed on your own. You are welcome to seek help from the course staff during office hours or use Piazza to ask questions and discuss with other students. For group projects, collaboration is encouraged on all aspects of the project and the writeup.
</p>
`

export const late_policy = `
<p>
You have <b>4 slack days</b> to use for any assignments or responses that have a late policy. These days are intended for minor illnesses, special occasions (e.g., interviews), or unexpected scenarios. Late submissions not covered by a slack day will incur a 10% grade deduction per day. Inform us before the deadline and specify how many days you'd like to use.
</p>
<p>
<b>Per university policy</b>: any student who needs to be excused for an absence must notify the instructor in a timely manner. The notification should be provided either prior to the absence or as soon afterwards as possible.
</p>
`

export const ai_policy = ` <p>The scope of AI tools includes, but is not limited to, GPT, Claude, Gemini, DALL-E, Midjourney, Copilot, and Hugging Face. 
                    <ul>
                        <li>AI should <b>not</b> be used to <b>directly</b> complete <b>labs</b> but you can use them in assisting in assignments, although we advise on ask AI to generate only small functions upon your own design.</li>
                        <li>Clearly <b>mark</b> any content that is directly generated by AI. </li>
                        <li>Be mindful about your <b>reliance</b> on AI, especially in terms of <b>trusting</b> AI-generated content. </li>
                        <li>You may use AI to <b>assist</b> with coursework, such as inquiring about terms, brainstorming, and improving writing. </li>
                        <li>You are encouraged to use AI <b>creatively</b> (in a good way)and share your thoughts and experiences with us.</li>
                        <li>Violations will result in a zero for the affected portion.</li>
                    </ul>
                </p>
`

export const support_text = `
We are committed to the full inclusion of all students. You should expect and demand respect from classmates and staff, and reciprocally, treat others with respect. If any incident challenges this commitment, please inform us immediately.

If you have a disability or condition that requires accommodations, please notify us early in the term. You can speak with us after class. For more information, contact Accessibility & Disability Services at (301) 314-7682 or adsfrontdesk@umd.edu.

For accessibility, please view <a href="https://www.umd.edu/web-accessibility" target="_blank" title="UMD Web Accessibility">Web Accessibility</a>.
`



export const acknowledgement = `
<p>The content of this class has been inspired by the classes and talks given by the following people:  
<b>Remco Chang</b> at Tufts University (<a href='https://www.fmyang.com/2015fallVISweb/public_html/'>COMP150VIZ</a>), 
<b>Arvind Satyanarayan</b> at MIT (<a href='https://vis.csail.mit.edu/classes/6.859/'>6.859</a>), 
<b>Matthew Kay</b> and <b>Maryam Hedayati</b> at Northwestern University (<a href='https://www.mccormick.northwestern.edu/computer-science/academics/courses/descriptions/333.html'>COMP_SCI 333</a> and their talks), 
<b>Leo Zhicheng Liu</b> at the University of Maryland College Park (CMSC471), 
<b>Paul Rosen</b> and <b>Alexander Lex</b> at The University of Utah (<a href='https://www.dataviscourse.net/2024/index.html'>DS-4630/CS-5630/CS-6630</a>), 
<b>Leilani Battle</b> and <b>Jeff Heer</b> at University of Washington (<a href='https://courses.cs.washington.edu/courses/cse442/'>CSE442/CSE512</a>), 
<b>Lane Harrison</b> at WPI (<a href='https://users.wpi.edu/~ltharrison/biovis/'>BCB 4002/502; CS 4802/582</a>), <b>Adam Perer</b> at Carnegie Mellon University (<a href='https://www.hcii.cmu.edu/course/interactive-data-science'>05-839</a>), 
 and <b>Karen Schloss</b> at the University of Wisconsin–Madison.

`